import axios from "axios";

export default axios.create({
	//baseURL: `https://digimart-server.onrender.com`,
	baseURL: `https://digimart-server.onrender.com`,
});
